import { Component } from '@angular/core';

@Component({
  selector: 'app-history-icon',
  templateUrl: './history-icon.component.html',
  styleUrls: ['./history-icon.component.scss']
})
export class HistoryIconComponent {

}
